import * as Immutable from 'seamless-immutable';
import {
  RECEIVE_BUSINESS_USER_DATA_FIRST_STEP,
  RECEIVE_CLEAR_BUSINESS_USER_DATA_FIRST_STEP,
} from '../Actions/actions';

const istate = {
  BusinessUserDataStep1: {},
};
export const initialState = Immutable.from(istate);
export default (state = initialState, { type, data }) => {
  switch (type) {
    case RECEIVE_BUSINESS_USER_DATA_FIRST_STEP:
      return {
        BusinessUserDataStep1: data,
      };
    case RECEIVE_CLEAR_BUSINESS_USER_DATA_FIRST_STEP:
      return {
        BusinessUserDataStep1: {},
      };


    default:
      return state;
  }
};
